export default __webpack_public_path__ + "static/media/back.c731ded3.svg";